import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import ProductDetail from "./ProductDetail";
import ProductTabs from "./ProductTabs";
import RelatedProducts from "./RelatedProducts";
import { actionToGetProductsDetailsApiCall } from "../../../redux/action";
import Loader from "../../Loader/Loader";
//import Review from "./Review";

export default function ProductDetailComponent() {
    const { product_slug } = useParams();
    const [isLoading,setIsLoading] = useState(true);
    const dispatch = useDispatch();

    // Fetch product detail data from the redux store
    const productError = useSelector((state) => state.product.productDetailError); // Assuming you have an error state in your Redux store

    // Fetch product details once on component mount
    useEffect(() => {
        setIsLoading(true);
        dispatch(actionToGetProductsDetailsApiCall({ product_slug })).then(res=>{
            setIsLoading(false);
        });
    }, [dispatch, product_slug]);
    // Render loading state while data is being fetched
    if ( isLoading) {
        return <Loader />;
    }

    // Render error state if there is an error in fetching product data
    if (productError) {
        return <div className="error">Error loading product details. Please try again later.</div>;
    }

    // Render product detail components when data is successfully fetched
    return (
        <div className='pt-20'>
            <ProductDetail />
            <ProductTabs />
            {/*<Review />*/}
            <RelatedProducts />
        </div>
    );
}
